// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__2rARh","dp":"About_dp__as-6k","aboutMe":"About_aboutMe__2bNq1","aboutInside":"About_aboutInside__2974g","colorgen":"About_colorgen__2Rqfq"};